import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { QueryParam } from '../query-param';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

import { Location } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
@Component({
  selector: 'app-mobile-dialog',
  templateUrl: './mobile-dialog.component.html',
  styleUrls: ['./mobile-dialog.component.css']
})
export class MobileDialogComponent implements OnInit {

  constructor(private apiService: ApiService, private activeModal: NgbActiveModal,
    private activatedRoute: ActivatedRoute, private router: Router) { }

  mobileNumber!: any;
 
  serviceid: any;
  popup_head :any;
  popup_title : any;
  popup_btn : any;


  addbalance = '';
  queryParam!: QueryParam;


  ngOnInit(): void {
    let storageName = this.apiService.getItem();
    this.queryParam = JSON.parse(
      localStorage.getItem(storageName) || 'undefined'
    );
    console.log('this.queryParam :', this.queryParam);


    if(this.queryParam.lang === 'AR'){
      this.popup_head = "رقم الهاتف المحمولتَحَقّق";
      this.popup_title = "أدخل رقم الهاتف المحمول مع رمز الدولة";
      this.popup_btn = "يُقدِّم";
    }else if (this.queryParam.lang === 'PT') {
      this.popup_head = "Verificação de número de celular";
      this.popup_title = "Para acessar sua assinatura, digite seu número de celular";
      this.popup_btn = "Enviar";
    }else{
      this.popup_head = "Mobile Number verification";
      this.popup_title = "Enter Mobile Number With Country Code : ";
      this.popup_btn = "SUBMIT";
    }
  }

  onMobileNumberChange(value: string) {
    const countryCode = '964';
    // Remove any non-digit characters from the input
    value = value.replace(/\D/g, '');
  
    // Ensure the input always starts with the country code
    this.mobileNumber = countryCode + value.slice(0, 10);
  }
  
  submit() {
    if (this.queryParam.biller != 'COMVIVA' && this.queryParam.id != '530' && '519' && '447') {
      console.log(this.mobileNumber);

      if (this.queryParam.id == '375' && this.queryParam.biller == 'QANAWAT') {
        if (this.queryParam.operator == '8966' || this.queryParam.operator == '9043') {
          this.apiService.getSubDataByID(this.mobileNumber, this.queryParam.serviceId).subscribe((res: any) => {
            let data = res;
            if (data.currentStstus == 'ACTIVE' && (data.substatus == 'ACTIVATED' || data.substatus == 'DEACTIVATED')) {
              this.router.navigate([], {
                queryParams: {
                  msisdn: this.mobileNumber
                },
                queryParamsHandling: 'merge',
              });
              this.activeModal.dismiss();
            } else if (data.lowBalanceMsg != null || data.lowBalanceMsg != undefined) {
              this.addbalance = data.lowBalanceMsg;
            } else {
              if (this.queryParam.lang == 'AR') {
                this.addbalance = "أنت غير مشترك"
              } else {
                this.addbalance = "You are not Subscribed"
              }
            }
          });
        } else {
          this.apiService.getHomeCompService(this.mobileNumber).subscribe((res: any) => {
            console.log(res)
            if (res == false) {
              this.addbalance = "You are not subscribed";
            }
            else {
              this.router.navigate([], {
                queryParams: {
                  msisdn: this.mobileNumber
                },
                queryParamsHandling: 'merge',
              });
              this.activeModal.dismiss();
            }
          });
        }
      } else if ((this.queryParam.id == '536' || this.queryParam.id == '490' || this.queryParam.id == '427' || this.queryParam.id == '563') && (this.queryParam.biller == 'Mobimind' || this.queryParam.biller == 'SLADigital') && (this.queryParam.operator == '2029' || this.queryParam.operator == '2025' || this.queryParam.operator == '9043' || this.queryParam.operator == '8040' || this.queryParam.operator == '8903' || this.queryParam.operator == '8966' || this.queryParam.operator == '8899')) {
        // need to add api here bhavesh ticket
        this.apiService.getSubDataByID(this.mobileNumber, this.queryParam.serviceId).subscribe((res: any) => {
          let data = res;
          if (data.currentStstus == 'ACTIVE') {
            this.router.navigate([], {
              queryParams: {
                msisdn: this.mobileNumber
              },
              queryParamsHandling: 'merge',
            });
            this.activeModal.dismiss();
          } else {
            if (this.queryParam.lang == 'AR') {

              this.addbalance = 'أنت غير مشترك'

            } else if (this.queryParam.lang == 'PT') {
              this.addbalance = 'Você não está inscrito'
            }
            else {
              this.addbalance = 'You are not subscribed'
            }
          }
        });
      } else if ((this.queryParam.id == '401') && this.queryParam.biller.toLowerCase() == "ALTRUS".toLowerCase()) {
        this.apiService.checkSubscriptionStatus(this.mobileNumber).subscribe((res: any) => {
          console.log(res)
          if (res == false) {
            this.addbalance = "You are not subscribed";
          }
          else {
            this.activeModal.dismiss()
          }
        })
      } else if ((this.queryParam.id === '502' || this.queryParam.id === '503') && this.queryParam.biller == 'Tetragram') {
        this.apiService.getSubDataByID(this.mobileNumber, this.queryParam.serviceId).subscribe((res: any) => {
          let data = res;
          if (data.currentStstus == 'ACTIVE') {
            this.router.navigate([], {
              queryParams: {
                msisdn: this.mobileNumber
              },
              queryParamsHandling: 'merge',
            });
            this.activeModal.dismiss();
          } else {
            this.addbalance = "You are not Subscribed"
          }
        });
      }
      else if (this.queryParam.id === '528' && this.queryParam.biller == 'ACTEL' && this.queryParam.operator == '2162') {
        if (!this.mobileNumber.startsWith('964')) {
          this.mobileNumber = '964' + this.mobileNumber;
        }
        
        this.apiService.getSubDataByID(this.mobileNumber, this.queryParam.serviceId).subscribe((res: any) => {
          let data = res;
          if (data.currentStstus == 'ACTIVE') {
            this.router.navigate([], {
              queryParams: {
                msisdn: this.mobileNumber
              },
              queryParamsHandling: 'merge',
            });
            this.activeModal.dismiss();
          } else {
            this.addbalance = "You are not Subscribed"
          }
        });
      }
       else if ((this.queryParam.id === '482' || this.queryParam.id === '547') && (this.queryParam.biller == 'Infovas') && (this.queryParam.operator == '2123')) {
        this.apiService.getSubDataByID(this.mobileNumber, this.queryParam.serviceId).subscribe((res: any) => {
          let data = res;
          if (data.currentStstus == 'ACTIVE') {
            this.router.navigate([], {
              queryParams: {
                msisdn: this.mobileNumber
              },
              queryParamsHandling: 'merge',
            });
            this.activeModal.dismiss();
          } else {
            this.addbalance = "You are not Subscribed"
          }
        });
      }else if(this.queryParam.id === '16' && this.queryParam.biller === 'TRENDYTECH'){
        this.apiService.getSubDataByID(this.mobileNumber, this.queryParam.serviceId).subscribe((res: any) => {
          let data = res;
          if (data.currentStstus == 'ACTIVE') {
            this.router.navigate([], {
              queryParams: {
                msisdn: this.mobileNumber
              },
              queryParamsHandling: 'merge',
            });
            this.activeModal.dismiss();
          } else {
            this.addbalance = "You are not Subscribed"
          }
        });
      }
       else if (this.queryParam.id == '532' && this.queryParam.biller == "Sunych") {
        // console.log("helllooooooooo")
        this.apiService.getSubDataByID(this.mobileNumber, this.queryParam.serviceId).subscribe((res: any) => {
          console.log("Response from getSubData", res);
        });
      }
    } else if (this.queryParam.id === '519' || '447' || '530' && this.queryParam.biller === 'COMVIVA') {
      let url = 'http://wap.matrixads.in/mglobopay/getSubDataById?msisdn=' + this.queryParam.msisdn + '&serviceid=' + this.queryParam.serviceId
      this.apiService.getSubDataByID(this.mobileNumber, this.queryParam.serviceId).subscribe(
        (res: any) => {


          // let data = JSON.parse(response);
          // console.log('JSON.parse(response)',JSON.parse(response));
          let data = res;

          // if(this.queryParam.id == '447' || this.queryParam.id == '532'){
          //   if(data.currentStstus == "ACTIVE"){
          //     response = "true";
          //   }else{
          //     response = "false";
          //   }
          // }

          if (data.currentStstus === 'ACTIVE') {
            this.queryParam.mobileNumber = this.mobileNumber;
            this.queryParam.msisdn = this.mobileNumber.toString();

            this.queryParam.sub = true;
            this.queryParam.popup = false;
            //  let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
            localStorage.setItem(this.apiService.getItem(), JSON.stringify(this.queryParam));
            console.log('Response :', this.queryParam);
            this.activeModal.close();

            const url = this.router.createUrlTree([], {
              relativeTo: this.activatedRoute,
              queryParams: { msisdn: this.mobileNumber },
              queryParamsHandling: "merge",
              preserveFragment: true
            }).toString()

            this.router.navigateByUrl(url);

          } else {
            this.addbalance = "You are not subscribed";

          }
        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );
    } 

    // this.activeModal.dismiss()

  }

  getConditionalDialogBox(mobileNumber: any) {
    if ((this.queryParam.id == '375') && this.queryParam.biller == "QANAWAT") {
      if (this.queryParam.operator == '9043') {
        return "http://wap.matrixads.in/mglobopay/getSubDataById?msisdn=" + mobileNumber + '&serviceid=' + 1227;
      } else {
        return "http://wap.matrixads.in/mglobopay/qanawatKSAPortalValidation/" + mobileNumber;
      }
    } else if ((this.queryParam.id == '401') && this.queryParam.biller.toLowerCase() == "ALTRUS".toLowerCase()) {

      return "http://wap.matrixads.in/mglobopay/altrusCheckSubscriptionStatus?msisdn=" + mobileNumber;

    } else if ((this.queryParam.id == '453' || this.queryParam.id == '454') && this.queryParam.biller.toLowerCase() == "MTNMONEY".toLowerCase()) {

      return "https://wap.matrixads.in/mglobopay//fetchMTNBeninSubscriptionStatus/" + this.queryParam.serviceId + "/" + mobileNumber;

    } else if ((this.queryParam.id == '481') && this.queryParam.biller.toLowerCase() == "ONE97".toLowerCase()) {

      return "https://wap.matrixads.in/mglobopay/uaeONSSubscriptionStatus?msisdn=" + mobileNumber;

    }
    else if ((this.queryParam.id == '420' || this.queryParam.id == '421') && this.queryParam.biller.toLowerCase() == "AirtelMoney".toLowerCase()) {

      return "https://wap.matrixads.in/mglobopay//fetchAirtelNigerSubscriptionStatus/" + this.queryParam.serviceId + "/" + mobileNumber;

    } else if (this.queryParam.id === '6' && this.queryParam.biller === 'TPAY' && (this.queryParam.operator === "9071" || this.queryParam.operator === "9073")) {
      return "http://wap.matrixads.in/mglobopay/tpaygamesworldPortalValidation/" + mobileNumber;
    } else if (this.queryParam.id === '297' && this.queryParam.biller === 'MediaWorld' && this.queryParam.operator === "8938") {
      return "http://wap.matrixads.in/mglobopay/mediaWorldSubscriptionStatus/52/" + mobileNumber;
    } else if ((this.queryParam.id == '416') && this.queryParam.biller.toLowerCase() == "MediaWorld".toLowerCase()) {

      if (this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') {
        this.queryParam.serviceId = "11166";
      }

      return "http://wap.matrixads.in/mglobopay/mediaWorldSubscriptionStatus/" + this.queryParam.serviceId + "/" + mobileNumber;

    } else if ((this.queryParam.id == '490' || this.queryParam.id == '427') && this.queryParam.biller.toLowerCase() == "SLADigital".toLowerCase()) {

      if ((this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') && this.queryParam.id == '490') {
        this.queryParam.serviceId = "1319";
      } else if ((this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') && this.queryParam.id == '427') {
        this.queryParam.serviceId = "1321";
      }

      return "http://wap.matrixads.in/mglobopay/SlaDigitalSubscriptionStatus?msisdn=" + mobileNumber + "&serviceId=" + this.queryParam.serviceId;

    } else if ((this.queryParam.id == '447') && this.queryParam.biller.toLowerCase() == "SLADigital".toLowerCase()) {

      // this.queryParam.serviceId = "1349";

      return "http://wap.matrixads.in/mglobopay/getSubDataById?serviceid=" + this.queryParam.serviceId + "&msisdn=" + mobileNumber;
    }

    else if ((this.queryParam.id == '447') && this.queryParam.biller.toLowerCase() == "SLADigital".toLowerCase()) {

      // this.queryParam.serviceId = "1349";

      return "http://wap.matrixads.in/mglobopay/getSubDataById?serviceid=" + this.queryParam.serviceId + "&msisdn=" + mobileNumber;
    }

    else if (this.queryParam.id == '532' && this.queryParam.biller.toLowerCase() == 'Sunych'.toLowerCase()) {

      return "http://103.127.157.215:8080/mglobopay/getSubDataById?serviceid=" + this.queryParam.serviceId + "&msisdn=" + mobileNumber;

    }

    else if (this.queryParam.id == '519' && this.queryParam.biller.toLowerCase() == 'COMVIVA'.toLowerCase()) {

    }
    else if (this.queryParam.id == '375' && this.queryParam.biller == 'QANAWAT') {
      this.apiService.getHomeCompService().subscribe((res: any) => {
        console.log((res))
        this.activeModal.close();
      })

    }

    return null;
  }

}
